// Pure decision logic for the V2 assignment actions menu — extracted so the branching (edit path,
// share links, and especially the class-scoped vs full delete) is unit-testable without rendering.
import constants from 'client/constants';

const assignmentResourceType = (isDraft: boolean): 'draft_assignments_v1' | 'assignments_v3' =>
  isDraft ? 'draft_assignments_v1' : 'assignments_v3';

export const getEditPath = (assignmentId: string, isDraft: boolean): string =>
  `/assignment-builder/create-assignment/${assignmentId}/settings${isDraft ? '/draft' : ''}`;

export const getShareUrl = (type: 'student' | 'educator', assignmentId: string): string =>
  type === 'student'
    ? `${constants.ALBERT_FULL_PATH}/assignment/${assignmentId}`
    : `${constants.ALBERT_FULL_PATH}/assignment-builder/create-assignment/${assignmentId}/settings`;

interface DeleteContext {
  assignmentId: string;
  classroomId?: string;
  isDraft: boolean;
}

// Class-scoped delete only unassigns this class (the assignment survives elsewhere); otherwise the
// assignment (or draft) is deleted outright. Returns the genericMandarkRequest resourcePath + body.
export const buildDeleteRequest = ({
  assignmentId,
  classroomId,
  isDraft
}: DeleteContext): {resourcePath: string[]; body: Record<string, unknown>} => {
  if (classroomId && !isDraft) {
    return {
      resourcePath: ['assignments_v3', assignmentId, 'relationships', 'classrooms_v1'],
      body: {data: [{id: classroomId, type: 'classrooms_v1'}]}
    };
  }
  return {resourcePath: [assignmentResourceType(isDraft), assignmentId], body: {}};
};

export const getInvalidateResourcePath = (isDraft: boolean): string[] => [
  assignmentResourceType(isDraft)
];

export const getDeleteConfirmationCopy = ({
  assignmentName,
  classroomId,
  isDraft
}: {
  assignmentName: string;
  classroomId?: string;
  isDraft: boolean;
}): string => {
  if (isDraft) {
    return 'Are you sure you want to delete this assignment?';
  }
  if (classroomId) {
    return `You are about to remove this class from ${assignmentName}. The assignment will still exist in any other classes it's assigned to. This action cannot be undone.`;
  }
  return 'This will delete the assignment for all classes and students. This action cannot be undone.';
};
